<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs :pt-5="$vuetify.breakpoint.lgAndUp">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap justify-center align-center pt-5 pb-10>
            <v-flex xs12 lg10>
              <v-card class="rounded-lg pt-7">
                <center>
                  <img
                    class="logo-cmp"
                    :src="require('@/assets/img/logoINETCMP.png')"
                    width="400"
                    alt=""
                  />
                </center>
                <v-card-text class="black--text" style="font-size: 16px">
                  <v-layout                  
                    row
                    wrap
                    justify-center
                    align-center
                    pt-4
                    pb-7
                  >
                    <v-flex xs12 lg11 pb-7>
                      <p class="pt-5"><b>หมายเลขความยินยอม : </b> {{ ConsentId }}</p>
                      <v-card outlined>
                        <v-card-text
                          class="black--text"
                          style="font-size: 16px"
                        >
                        <p>
                          <b class="pb-2" style="font-size: 22px"
                            >รายละเอียดความยินยอม
                          </b>
                        </p>
                        <p><b>องค์กร : </b> {{ BusinessNameTh }}</p>
                        <p><b>สร้างโดย : </b> {{ UpdatdeBy }}</p>
                        <p><b>อายุเอกสาร (ปี) : </b> {{ ExpireIn }}</p>
                        <v-flex xs11 lg11 pb-3>
                          <b>ข้อมูลที่ต้องการขอ :</b>
                          <v-chip 
                            small
                            style="border: 1px solid"
                            v-for="(item, i) in itemsRequestTag"
                            :key="i"
                            class="ma-1"
                            label
                            text-color="#077893"
                            color="#ddf7ff"
                          >
                            <b>{{ item }}</b>
                          </v-chip>
                        </v-flex> 
                        <v-flex xs11 lg11 pb-3>
                          <b>TagSource :</b>
                          <v-chip
                            small
                            style="border: 1px solid"
                            v-for="(item, i) in itemsRequestTagSource"
                            :key="i"
                            class="ma-1"
                            label
                            text-color="#077893"
                            color="#ddf7ff"
                          >
                            <b>{{ item }}</b>
                          </v-chip>
                        </v-flex>
                        <p><b>หัวข้อความยินยอม : </b> {{ Title }}</p>
                        <p><b>รายละเอียดความยินยอมแบบย่อ : </b> {{ ShortConsent }}</p>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex  xs12 lg11 pb-7>
                      <v-card outlined>
                        <v-card-text
                          class="black--text"
                          style="font-size: 16px"
                        >
                        <v-card-title primary-title>รายละเอียดหากยินยอม</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-layout row wrap pa-2>
                            <v-flex xs11 lg11>
                              <p>{{ DetailsConsent }}</p>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex  xs12 lg11>
                      <v-card outlined>
                        <v-card-text
                          class="black--text"
                          style="font-size: 16px"
                        >
                        <v-card-title primary-title>รายละเอียดหากไม่ยินยอม</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-layout row wrap pa-2>
                            <v-flex xs11 lg11>
                              <p>{{ RejectReason }}</p>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-center
                    pt-4
                    pb-7
                    v-if="NameBtnSave == 'อนุมัติความยินยอม'"
                  >
                    <v-flex xs7 sm7 md2 lg2>
                      <v-btn :loading="load" 
                      color="#077893" 
                      dark 
                      block 
                      @click="Fn_Save"
                      >
                        {{ NameBtnSave }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout 
                    row
                    wrap
                    justify-center
                    align-self-center
                    pb-4 
                    v-else
                  >
                    <v-flex xs12 lg4 pt-4>
                      <v-alert border="left" dense text type="success">
                        {{ NameBtnSave }}
                      </v-alert>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Layout from '../../../components/layouts/Layout'
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    Layout, OverlaySearch },
  data: function () {
    return {
      load: false,
      loadingDownloadData: false,
      valid: true,
      ChatAccountId: "",
      AccountId: "",
      ConsentId: "",
      BusinessNameTh: "",
      Title: "",
      DetailsConsent: "",
      UpdatdeBy: "",
      UpdatdeAt: "",
      Manage: "",
      NameBtnSave: "อนุมัติความยินยอม",
      ShowStatus: true,
      itemsRequestTag: [],
      itemsRequestTagSource: [],
      ExpireIn: "",
      ShortConsent: "",
      RejectReason: "",
      TagSource: "",
      Tag: "",
    };
  },
  computed: {
    // ...mapGetters(["DataGroupConsent"]),
    // ...mapGetters(["Business"]),
    // ...mapGetters(["RoleAccount"]),
    // _RoleAccount: {
    //   get() {
    //     return this.RoleAccount || "-";
    //   },
    // },
    // _SendId: {
    //   get() {
    //     return this.DataGroupConsent.SendId || "-";
    //   },
    // },
  },
  mounted() {
    this.Fn_GetToken();
  },
  methods: {
    async Fn_GetToken() {
      this.loadingDownloadData = true;
      var payload = {
        ShareToken: this.$route.path.split("/")[4],
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "token/login",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.AccessToken = response.data.Message.OneAccessToken;
            this.ChatAccountId = response.data.Message.OneAccountId;
            this.$cookies.set("ChatAccountId", response.data.Message.OneAccountId);
            this.Fn_getDataConsent();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_getDataConsent() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$route.path.split("/")[2],
        ConsentId: this.$route.path.split("/")[3],
        AccessToken: this.AccessToken,
      };
      var Headers = {
        AccountId: this.ChatAccountId,
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "consent/GetConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          if (response.data.Status === "OK") {
            this.DataConsent = response.data.Message;
            this.ConsentId = this.DataConsent[0].ConsentId;
            this.AccountId = this.DataConsent[0].AccountId;
            this.BusinessNameTh = this.DataConsent[0].BusinessNameTh;
            this.Title = this.DataConsent[0].Title;
            this.DetailsConsent = this.DataConsent[0].DetailsConsent;
            this.RejectReason = this.DataConsent[0].RejectReason;
            this.ShortConsent = this.DataConsent[0].ShortConsent;
            this.Tag = this.DataConsent[0].Tag;
            this.UpdatdeBy = this.DataConsent[0].UpdatdeBy;
            this.UpdatdeAt = this.DataConsent[0].UpdatdeAt;
            this.Manage = this.DataConsent[0].Manage;
            this.ExpireIn = this.DataConsent[0].ExpireIn;
            this.TagSource = this.DataConsent[0].TagSource;
            if (this.Manage == "enable") {
              this.NameBtnSave = "ความยินยอมนี้ได้ทำการอนุมัติเรียบร้อยแล้ว";
              this.ShowStatus = false;
            } else {
              this.NameBtnSave = "อนุมัติความยินยอม";
              this.ShowStatus = true;
            }
            var FixArrayTag = response.data.Message[0].Tag;
            if (FixArrayTag == "") {
            } else {
              this.itemsRequestTag = FixArrayTag.split(",").map((item) => item.trim());
            }
            var FixArrayTagSource = response.data.Message[0].TagSource;
            if (FixArrayTagSource == "") {
            } else {
              this.itemsRequestTagSource = FixArrayTagSource.split(",").map((item) =>
                item.trim()
              );
            }
          } else {
            window.close();
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          window.close();
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Save() {
      this.load = true;
      var payload = {
        AccessToken: this.AccessToken,
        BusinessId: this.$route.path.split("/")[2],
        ConsentId: this.$route.path.split("/")[3],
        AccountId: this.AccountId,
        Title: this.Title,
        DetailsConsent: this.DetailsConsent,
        RejectReason: this.RejectReason,
        ShortConsent: this.ShortConsent,
        Tag: this.Tag,
        TagSource: this.TagSource,
        ExpireIn: this.ExpireIn,
        Manage: "enable",
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "consent/UpdateConsent",
          payload
        )
        .then((response) => {
          this.load = false;
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.NameBtnSave = "คุณได้อนุมัติความยินยอมเรียบร้อยแล้ว";
            this.ShowStatus = false;
            this.Fn_getDataPolicy();
            Toast.fire({
              icon: "success",
              title: "อนุมัติความยินยอมสำเร็จ",
            });
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.load = false;
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Cancle() {
      window.close();
      this.$refs.formData.reset();
    },
  },
  watch: {},
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.bg-card {
  background-color: #eeeeee;
}
</style>
